import React, { useState } from 'react';
import './MainPage.css';
import diwaLogoBlack from '../resources/images/diwalogotext.svg';
import diwaLogoColor from '../resources/images/diwalogocolor.svg';

export function MainPage() {
  const [lightMode, setLightMode] = useState(true);

  // Show DIWA logo (main page content to be decided by PO)
  return (
    <div className="centering">
      <div className="glow-on-hover">
        {
          <img
            className="diwa-logo"
            alt="DIWA"
            draggable={false}
            src={lightMode ? diwaLogoColor : diwaLogoBlack}
            onMouseDown={() => setLightMode(false)}
            onMouseUp={() => setLightMode(true)}
            onMouseLeave={() => setLightMode(true)}
          />
        }
      </div>
    </div>
  );
}
